export const POST_ACTION_EDIT = 'edit';
export const POST_ACTION_SHARE = 'share';
export const POST_ACTION_PRINT = 'print';
export const POST_ACTION_DELETE = 'delete';
export const POST_ACTION_TRANSLATE = 'translate';
export const POST_ACTION_CHANGE_LANGUAGE = 'change-language';

export const POST_ACTIONS = [
  POST_ACTION_EDIT,
  POST_ACTION_SHARE,
  POST_ACTION_PRINT,
  POST_ACTION_DELETE,
  POST_ACTION_TRANSLATE,
  POST_ACTION_CHANGE_LANGUAGE,
] as const;

export type PostAction =
  | typeof POST_ACTION_EDIT
  | typeof POST_ACTION_SHARE
  | typeof POST_ACTION_PRINT
  | typeof POST_ACTION_DELETE
  | typeof POST_ACTION_TRANSLATE
  | typeof POST_ACTION_CHANGE_LANGUAGE;
